export const CLEAR_STORE = 'realtime-client/clear-chat-store';
export const REQUEST_TRANSLATIONS = 'realtime-client/request-translations';
export const REQUEST_LANGUAGE_SUCCEEDED = 'realtime-client/request-language-succeeded';
export const TOGGLE_CHAT_SOUND = 'realtime-client/toggle-chat-sound';
export const TOGGLE_CHAT_TRANSLATE = 'realtime-client/toggle-chat-translate';
export const CREATE_SYSTEM_MESSAGE = 'realtime-client/create-system-message';

// FILE UPLOAD
export const OPEN_FILE_UPLOAD_WINDOW = 'realtime-client/show-file-upload-window';
export const SAVE_FILE_FOR_UPLOAD = 'realtime-client/save-file-for-upload';
export const REMOVE_FILE_FOR_UPLOAD = 'realtime-client/remove-file-for-upload';
export const FILE_UPLOAD_DISABLED_CODE = 'FILE_UPLOAD_DISABLED';
export const FILE_UPLOAD_DISABLED_INTL_KEY = 'translate.system.message.file.upload.disabled';

/**
 * @typedef {Object} CHAT_STATE
 * @property {string} IDLE
 * @property {string} LOGIN_PRESALES
 * @property {string} REQUESTING_CHAT
 * @property {string} NO_AVAILABLE_OPERATOR
 * @property {string} FAILED_AUTHENTICATION_WITH_CLUSTER
 * @property {string} CURRENTLY_CHATTING
 * @property {string} IN_PROGRESS
 * @property {string} FILE_UPLOAD_ENABLED
 * @property {string} OPERATOR_LOST_CONNECTION
 * @property {string} ENDED_BY_USER
 * @property {string} ENDED
 * @property {string} AUTHENTICATED_INQUIRY
 */

/** @type {CHAT_STATE} */
export const CHAT_STATE = {
  IDLE: 'idle',
  LOGIN_PRESALES: 'login-presales',
  REQUESTING_CHAT: 'requesting-chat',
  NO_AVAILABLE_OPERATOR: 'no-available-operator',
  CURRENTLY_CHATTING: 'currently-chatting',
  FAILED_AUTHENTICATION_WITH_CLUSTER: 'failed-authentiaction-with-cluster',
  IN_PROGRESS: 'in-progress',
  FILE_UPLOAD_ENABLED: 'file-upload-enabled',
  OPERATOR_LOST_CONNECTION: 'operator-lost-connection',
  ENDED_BY_USER: 'ended-by-user',
  ENDED: 'ended',
  AUTHENTICATED_INQUIRY: 'authenticated-inquiry'
};

export const SYSTEM_MESSAGE_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  INSTRUCTION: 'info'
};
